module.exports = __webpack_public_path__ + "static/img/bgborder.93aad3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgborder.png
// module id = MDt4
// module chunks = 1